import {
  createHashRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
} from 'react-router-dom';
import EventAvailabilityGuard from '@guards/EventAvailability.guard.jsx';
import { routes } from '@navigation/routes.js';
import { AppProvider } from '@providers/App.provider.jsx';
import ErrorBoundaryComponent from '@components/ErrorBoundary.component.jsx';

export const router = createHashRouter(
  createRoutesFromElements(
    <Route
      errorElement={<ErrorBoundaryComponent />}
      element={
        <>
          <AppProvider>
            <EventAvailabilityGuard>
              <Outlet />
            </EventAvailabilityGuard>
          </AppProvider>
        </>
      }
    >
      {routes.map(
        // eslint-disable-next-line
        ({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ),
      )}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>,
  ),
);
